define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("RevertToDraft", _StateAction, {
		m_tag: "RevertToDraft"
	});
});